<template>
  <div>
    <v-dialog v-model="dialog" :max-width="options.width" @keydown.esc="cancel()">
      <v-card tile class="pt-3">
        <v-card-text v-show="!!message" class="text-xs-center py-2" :style="options.style" v-html="message"></v-card-text>
        <!-- <v-divider></v-divider> -->
        <v-card-actions class="px-4 py-3">
          <!-- <v-spacer></v-spacer> -->
          <v-btn v-if="options.info" block large outline color="info" id="confirm_info" @click.native="cancel()">OK</v-btn>
          <v-btn v-if="!options.info" block large outline color="error" id="confirm_no" @click.native="cancel()">No</v-btn>
          <v-btn v-if="!options.info" block large outline color="success" id="confirm_yes" @click.native="agree()">Yes</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
/**
   *
   * Insert component where you want to use it:
   * <confirm ref="confirm"></confirm>
   *
   * Call it:
   * this.$refs.confirm.open('Delete', 'Are you sure?', { color: 'red' }).then((confirm) => {});
   *
   * Alternatively you can place it in main App component and access it globally via this.$root.$confirm
   *<template>
     *
    <v-app>
      * ... *
      <confirm ref="confirm"></confirm>
      * </v-app>
    *
  </template>
   *
   * mounted() {
   *   this.$root.$confirm = this.$refs.confirm.open;
   * }
   */
export default {
  name: "confirm",
  data() {
    return {
      dialog: false,
      resolve: null,
      message: null,
      title: null,
      options: {}
    };
  },
  methods: {
    open(title, message, options) {
      // console.log(title, message, options);
      this.init();
      this.dialog = true;
      this.title = title;
      this.message = message;
      this.options = Object.assign(this.options, options);
      return new Promise(resolve => {
        this.resolve = resolve;
      });
    },
    agree() {
      this.resolve(true);
      this.dialog = false;
    },
    cancel() {
      this.resolve(false);
      this.dialog = false;
    },
    init() {
      this.options = {
        color: "error",
        width: 350,
        showTitle: true,
        info: false,
        style: {
          "font-size": "20px",
          "font-weight": "500px",
          "min-height": "75px"
        }
      };
    }
  },
  created() {
    this.init();
  }
};
</script>